<div class="d-flex flex-column g-g config-subsection">
  <div class="config-subsection-title">Band</div>
  <oaibox-band-create-configuration class="flex-fill align-items-center g-g"
                                    [editableBandOptions]="editableRanConfiguration?.band"
                                    [defaultBandOptions]="defaultRanConfiguration?.band"
                                    (optionsChange)="updateBand($event)">
  </oaibox-band-create-configuration>
</div>

<div class="d-flex flex-column g-g config-subsection">
  <div class="config-subsection-title">Bandwidth</div>
  <oaibox-bandwidth-create-configuration class="flex-fill align-items-center g-g"
                                         [editableBandwidthOptions]="editableRanConfiguration?.bandwidth"
                                         [defaultBandwidthOptions]="defaultRanConfiguration?.bandwidth"
                                         (optionsChange)="updateBandwidth($event)">
  </oaibox-bandwidth-create-configuration>
</div>

<div class="d-flex flex-column g-g config-subsection">
  <div class="config-subsection-title">FDD Bandwidth</div>
  <oaibox-bandwidth-create-configuration class="flex-fill align-items-center g-g"
                                         [editableBandwidthOptions]="editableRanConfiguration?.fddBandwidth"
                                         [defaultBandwidthOptions]="defaultRanConfiguration?.fddBandwidth"
                                         (optionsChange)="updateFDDBandwidth($event)">
  </oaibox-bandwidth-create-configuration>
</div>

<div class="d-flex flex-column g-g config-subsection">
  <div class="config-subsection-title">TDD</div>
  <oaibox-tdd-create-configuration class="flex-fill align-items-center g-g"
                                   [editableTddOptions]="editableRanConfiguration?.tdd"
                                   [defaultTddOptions]="defaultRanConfiguration?.tdd"
                                   (optionsChange)="updateTdd($event)">
  </oaibox-tdd-create-configuration>
</div>

<div class="d-flex flex-column g-g config-subsection">
  <div class="config-subsection-title">Modulation Order</div>
  <div>
    <div class="form-label">Downlink</div>
    <oaibox-modulation-order-create-configuration class="flex-fill align-items-center g-g"
                                                  [editableModulationOrderOptions]="editableRanConfiguration?.modulationOrder?.downlinkOptions"
                                                  [defaultModulationOrderOptions]="defaultRanConfiguration?.modulationOrder?.downlinkOptions"
                                                  (optionsChange)="updateModulationOrderDownlink($event)">
    </oaibox-modulation-order-create-configuration>
  </div>
  <div>
    <div class="form-label">Uplink</div>
    <oaibox-modulation-order-create-configuration class="flex-fill align-items-center g-g"
                                                  [editableModulationOrderOptions]="editableRanConfiguration?.modulationOrder?.uplinkOptions"
                                                  [defaultModulationOrderOptions]="defaultRanConfiguration?.modulationOrder?.uplinkOptions"
                                                  (optionsChange)="updateModulationOrderUplink($event)">
    </oaibox-modulation-order-create-configuration>
  </div>
</div>

<div class="d-flex flex-column g-g config-subsection">
  <div class="config-subsection-title">MIMO Configuration</div>
  <div>
    <div class="form-label">MIMO</div>
    <oaibox-mimo-create-configuration class="flex-fill align-items-center g-g"
                                     [editableMimoOptions]="editableRanConfiguration?.mimoOptions"
                                     [defaultMimoOptions]="defaultRanConfiguration?.mimoOptions"
                                     (optionsChange)="updateMimoConfiguration($event)">
    </oaibox-mimo-create-configuration>
  </div>
</div>
